import {
  Box,
  FormHelperText,
  InputAdornment,
  InputAdornmentProps,
  Typography,
  useTheme,
} from '@mui/material';
import { ReactNode } from 'react';
import Icon from '../../IconSvg/Icon';

export type LelyFieldSharedProps = {
  showHelperText?: boolean;
  helperText?: ReactNode;
  valid?: boolean;
  showUnitText?: boolean;
  unitText?: string;
};

export function shouldShowLelyFieldUnitText(
  showUnitText?: boolean,
  unitText?: string,
) {
  return showUnitText ?? Boolean(unitText);
}

export function LelyFieldHelperText({
  showHelperText,
  helperText,
  valid = true,
}: Pick<LelyFieldSharedProps, 'showHelperText' | 'helperText' | 'valid'>) {
  const theme = useTheme();
  const shouldShowHelperText = showHelperText ?? Boolean(helperText);

  if (!shouldShowHelperText) {
    return null;
  }

  const helperTextContent = !valid ? (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.lelySpacing.XS,
        color: theme.palette.text.brandPrimary,
      }}
    >
      <Icon
        name="lely-icon-information"
        style={{
          color: 'currentColor',
          width: theme.lelyLineHeight.BASE,
          height: theme.lelyLineHeight.BASE,
        }}
      />
      <Typography variant="xs" color="error">
        {helperText}
      </Typography>
    </Box>
  ) : (
    <Typography variant="xs" color="text.subtle">
      {helperText}
    </Typography>
  );

  return <FormHelperText error={!valid}>{helperTextContent}</FormHelperText>;
}

export function LelyFieldUnitAdornment({
  unitText,
  sx,
}: {
  unitText?: string;
  sx?: InputAdornmentProps['sx'];
}) {
  return (
    <InputAdornment
      position="end"
      sx={[
        { pointerEvents: 'none' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <Typography component="span" variant="xs" color="text.subtle">
        {unitText}
      </Typography>
    </InputAdornment>
  );
}
